import {Container} from "react-bootstrap"
//file contains static covid policy
const CovidPolicyPage = () => {
    return (
        <Container>
        <br />
        <br />
        <br />
               <h1> Covid Return Policy</h1> <br />        
               <ul>
                   <li>
                       All returns will be Sanitized at facility, you do not have to sanitize items.
                   </li>
                   <li>
                       Clothes will not be taken back, however, we are willing to give store credit for the item.
                   </li>
                   <li>
                       Exchange and return time limited to 2 days from purchase.
                   </li>
                   <li>
                       Please use caution while interacting with delivery drivers and schedule no contact pick up if possible.
                   </li>
               </ul>
           </Container>
    )
}

export default CovidPolicyPage
